// src/components/PedidosCocina.jsx
import React, { useState, useEffect } from "react";
import clienteAxios from "../../axios";
import ModalConfirm from "../ModalConfirm";
import ModalAgregarPedido from './ModalAgregarPedido'; // Importamos el nuevo modal para agregar pedidos


const PedidosCocina = ({ cocinaId }) => {
    const [pedidos, setPedidos] = useState([]);
    const [busqueda, setBusqueda] = useState("");
    const [editandoPedido, setEditandoPedido] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [pedidoSeleccionado, setPedidoSeleccionado] = useState(null);
    const [nombreCocina, setNombreCocina] = useState(""); // Estado para almacenar el nombre de la cocina
    const [showAgregarPedidoModal, setShowAgregarPedidoModal] = useState(false);  // Estado para mostrar el modal


    // Función para obtener los datos de la cocina usando el cocinaId
    const obtenerCocina = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "cocinas"
            });

            const cocina = response.data.data[0].find(item => item.id === cocinaId);
            if (cocina) {
                setNombreCocina(cocina.nombre); // Almacenar el nombre de la cocina
            }
        } catch (error) {
            console.log(error);
        }
    };

    // Función para obtener los pedidos de cocina
    const obtenerPedidosCocina = async () => {
        try {
            const response = await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Listar",
                modulo: "pedidos_cocina"
            });
            setPedidos(response.data.data[0].filter(item => item.cocina_id === cocinaId));
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {        
        obtenerCocina(); // Llamamos la función para obtener los detalles de la cocina
        obtenerPedidosCocina(); // Obtenemos los pedidos al cargar el componente
    }, [cocinaId]);

    // Función para manejar la barra de búsqueda
    const handleBusqueda = (e) => {
        setBusqueda(e.target.value.toLowerCase());
    };

    const pedidosFiltrados = pedidos.filter(item =>
        item.estado.toLowerCase().includes(busqueda)
    );

    // Función para editar pedido
    const editarPedido = (pedidoItem) => {
        setEditandoPedido(pedidoItem);
    };

    // Función para guardar pedido editado
    const guardarPedidoEditado = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Actualizar",
                modulo: "pedidos_cocina",
                id: editandoPedido.id,
                cocina_id: editandoPedido.cocina_id,
                comanda_id: editandoPedido.comanda_id,
                estado: editandoPedido.estado
            });
            setEditandoPedido(null);
            obtenerPedidosCocina(); // Actualizar lista
        } catch (error) {
            console.log(error);
        }
    };

    // Función para eliminar pedido
    const confirmarEliminarPedido = (pedidoItem) => {
        setPedidoSeleccionado(pedidoItem);
        setShowConfirmModal(true);
    };

    const eliminarPedido = async () => {
        try {
            await clienteAxios.post("/api/sp", {
                sp: "tools",
                op: "Eliminiar",
                modulo: "pedidos_cocina",
                id: pedidoSeleccionado.id
            });
            setShowConfirmModal(false);
            obtenerPedidosCocina(); // Actualizar lista
        } catch (error) {
            console.log(error);
        }
    };

    // Función para abrir el modal de agregar pedido
    const handleAbrirAgregarPedidoModal = () => {
        setShowAgregarPedidoModal(true);
    };

    // Función para cerrar el modal de agregar pedido
    const handleCerrarAgregarPedidoModal = () => {
        setShowAgregarPedidoModal(false);
    };

    return (
        <div>
            {/* Mostrar pedidos si el botón ha sido presionado */} 
            <div className="mt-4 border p-4 rounded-lg">
                <h3 className="text-lg font-semibold">Pedidos de la Cocina: {nombreCocina}</h3>

                {/* Barra de búsqueda */} 
                <input
                    type="text"
                    placeholder="Buscar estado..."
                    value={busqueda}
                    onChange={handleBusqueda}
                    className="border rounded-lg p-2 mb-4 mt-2 w-1/2 min-w-[200px]"
                />

                {/* Botón para abrir el modal de agregar pedido */} 
                <button
                    onClick={handleAbrirAgregarPedidoModal}
                    className="bg-blue-500 text-white px-4 py-2 rounded ml-2 hover:bg-blue-400"
                >
                    Agregar Nuevo Pedido
                </button>

                <ul>
                    {pedidosFiltrados.map((item) => (
                        <li key={item.id} className="border p-2 mb-2 mt-4">
                            {editandoPedido && editandoPedido.id === item.id ? (
                                <>
                                <h3 className=" font-semibold mt-2">Estado del Pedido:</h3>
                                    <input
                                        type="text"
                                        value={editandoPedido.estado}
                                        onChange={(e) =>
                                            setEditandoPedido({ ...editandoPedido, estado: e.target.value })
                                        }
                                        className="border rounded-lg p-2 mr-2"
                                        maxLength={20}
                                    />
                                     <div className="flex mt-4 mb-2">
                                    <button
                                        onClick={guardarPedidoEditado}
                                        className="bg-green-500 text-white rounded px-2 py-1 mt-2 w-40"
                                    >
                                        Guardar
                                    </button>
                                    <button
                                        onClick={() => setEditandoPedido(null)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 ml-2 w-40"
                                    >
                                        Cancelar
                                    </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <span><strong>Pedido ID:</strong> {item.id}</span><br />
                                    <span><strong>Comanda ID:</strong> {item.comanda_id}</span><br />
                                    <span><strong>Estado:</strong> {item.estado}</span><br />
                                    <button
                                        onClick={() => editarPedido(item)}
                                        className="bg-gray-500 text-white rounded px-2 py-1 mt-2 hover:bg-gray-400"
                                    >
                                        Editar
                                    </button>
                                    <button
                                        onClick={() => confirmarEliminarPedido(item)}
                                        className="bg-red-600 text-white rounded px-2 py-1 mt-2 ml-2 hover:bg-red-500"
                                    >
                                        Eliminar
                                    </button>
                                </>
                            )}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Modal de confirmación */} 
            <ModalConfirm
                show={showConfirmModal}
                message="¿Estás seguro de que quieres eliminar este pedido?"
                onConfirm={eliminarPedido}
                onCancel={() => setShowConfirmModal(false)}
            />

            {/* Modal para agregar nuevo pedido */} 
            <ModalAgregarPedido
                show={showAgregarPedidoModal}
                onClose={handleCerrarAgregarPedidoModal}
                cocinaId={cocinaId}
                onPedidoAgregado={obtenerPedidosCocina}  // Actualiza la lista de pedidos al agregar
            />
        </div>
    );
};

export default PedidosCocina;
